import React from "react";

import { LineChart } from "..";

export const LineChartTimeline = ({
  data,
  markers,
  axisLeftLegend,
  axisBottomLegend,
}: any): React.ReactElement => (
  <LineChart
    data={data}
    axisLeftLegend={axisLeftLegend}
    axisBottom={{
      format: "%b %d",
      legend: axisBottomLegend,
      legendOffset: 40,
      legendPosition: "middle",
    }}
    xFormat="time:%d-%m-%Y"
    xScale={{
      type: "time",
      format: "%d-%m-%Y",
      useUTC: false,
      precision: "day",
    }}
    markers={markers}
    pointSize={4}
  />
);
